import './userMenu.scss'
import templateUrl from './userMenu.html'
import contentTemplateUrl from './userMenu.content.html'

/**
 * User Menu component.
 *
 * @example
 * <tmr-user-menu user="$ctrl.loggedUser"></tmr-user-menu>
 *
 * @type {ngComponent}
 */
export const tmrUserMenu = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrUserMenuController',
  bindings: {
    user: '<',
  },
}

/**
 * Controller of component {@link tmrUserMenu}.
 *
 * @type {ngController}
 */
export class tmrUserMenuController {
  static ngType = 'controller'

  constructor($mdMedia, TmrLocalStorage) {
    'ngInject'
    Object.assign(this, {
      $mdMedia,
      content: contentTemplateUrl,
      TmrLocalStorage,
    })
  }

  $onInit() {
    if (this.user.id)
      this.userInitials = this.user
        .$getFullName()
        .split(' ')
        .map(word => word.charAt(0))
        .join('')
  }

  gtXs() {
    return this.$mdMedia('gt-xs')
  }

  /** Returns true if the sidebar is expanded */
  isExpanded() {
    return this.TmrLocalStorage.get('sidebarExpanded', true)
  }
}
